import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { PageResponse } from '../../_shared/types/shared';
import type { CertificateRow, CertificateFormValues, CertificateFilters } from '../types/certificate';

export const certificatesApi = {
  list: async (params: CertificateFilters & { page: number; size: number; sort?: string }) => {
    const response = await gatewayApiClient.get<PageResponse<CertificateRow>>('/admin/certificates', { params });
    return response.data;
  },

  get: async (id: string) => {
    const response = await gatewayApiClient.get<CertificateRow>(`/admin/certificates/${id}`);
    return response.data;
  },

  create: async (body: CertificateFormValues) => {
    const response = await gatewayApiClient.post<CertificateRow>('/admin/certificates', body);
    return response.data;
  },

  replace: async (id: string, body: CertificateFormValues) => {
    const response = await gatewayApiClient.put<CertificateRow>(`/admin/certificates/${id}`, body);
    return response.data;
  },

  delete: async (id: string) => {
    await gatewayApiClient.delete(`/admin/certificates/${id}`);
  },
};
